import { createRoot } from 'react-dom/client';
import { App } from './App';
import { OAuthProviders } from './auth/OAuthProviders';
import { initAnalytics } from './lib/analytics';
// Design system Tilde — variables semánticas (dark/light) + control library.
// Se importa antes de montar React para que las custom properties (--font-*, --primary,
// etc.) estén disponibles tanto para MUI (vía theme.ts) como para las páginas de marketing.
import './styles/tilde-tokens.css';

// Product analytics (PostHog). No-op si VITE_POSTHOG_KEY no está seteada (ver ADR 0010).
initAnalytics();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root container in index.html.');
}

// Slice I — wrappear con GoogleOAuthProvider + MsalProvider en el nivel más externo así los
// botones SSO (que pueden vivir en cualquier subtree, pero hoy solo en /login y /signup) pueden
// usar los hooks `useGoogleLogin` y `useMsal` sin re-instanciar el SDK por cada render.
// NOTA: sin StrictMode. El doble-mount de StrictMode (dev) rompe el flujo popup de MSAL v5:
// registra el callback de interacción dos veces y deja `acquireToken` colgado (inProgress nunca
// vuelve a 'none'), por lo que el login con Microsoft nunca completaba. MSAL + StrictMode es una
// incompatibilidad conocida; StrictMode es solo dev (no afecta prod).
createRoot(container).render(
  <OAuthProviders>
    <App />
  </OAuthProviders>,
);
